/**
 * Frontend entry point for esbuild.
 * Exposes required globals and imports application modules in dependency order.
 */

// App CSS
import '../../public/css/style.min.css';
import '../../public/css/themes.min.css';
import '../../public/css/maplibre-app.css';
import '../../public/css/themes-pro.min.css';
import '../../public/css/maplibre-gl-terradraw.css';
import '../../public/css/index-inline.css';

// Vendor globals must be set before any application module runs
import './globals.js';

// Frontend error reporting (initialised on import)
import './error-reporter.js';

// Style builder (exposed for webmap-engine and other components)
import * as styleBuilder from './style-builder.js';
window.__styleBuilder = styleBuilder;

// Shared data modules
import '../../public/js/region-data.js';
import '../../public/js/vri-data.js';

// Application modules (order matters)
import '../../public/js/menu-bar-loader.js';
import '../../public/js/admin-menu.js';
import '../../public/js/map-tools.js';
import '../../public/js/webmap/webmap-engine.js';
import '../../public/js/webmap/webmap-markers.js';
import '../../public/js/webmap/webmap-polygons.js';
import '../../public/js/webmap/webmap-ui.js';
import '../../public/js/swr.js';
import '../../public/js/ui-core.js';
import '../../public/js/auth-modal.js';
import '../../public/js/analytics.js';
import '../../public/js/terradraw-init.js';
import '../../public/js/prefetch.js';

console.log('[Frontend bundle] loaded');
